import { pathOr } from 'ramda';

import { IState } from '../store';

export function getVillageId(state: IState): number | null {
  return pathOr(null, ['offerData', 'offer', 'kp', 'id'], state);
}
